// @flow
import React from 'react';
import ImageCropper from '../ImageCropper/ImageCropper';

import './AvatarInput.css';

type AvatarInputProps = {
  avatarImage: File;
  setLogo: any;
};

type AvatarInputState = {
  avatarImage?: File;
  isCropping: boolean;
  thumbnailImageData: ?string;
};

export default class AvatarInput extends React.Component<any, AvatarInputProps, AvatarInputState> {
  state: AvatarInputState = {
    isCropping: false,
    thumbnailImageData: null
  };

  constructor(props: AvatarInputProps) {
    super(props);
    this.state = {
      avatarImage: props.avatarImage,
      isCropping: false,
      thumbnailImageData: ''
    }
    this.onInputChanged = this.onInputChanged.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.setThumbnail = this.setThumbnail.bind(this);
  }

  onInputChanged = (evt: Event & {target: HTMLInputElement}): void => {
    const target = evt.target;
    if (target.type === 'file') {
      console.log(target.files[0]);
      this.setState({
        avatarImage: target.files[0],
        isCropping: true
      }, () => {  // TODO: Remove
        console.log(this.state);
      });
    }
  }

  closeModal = (): void => {
    this.setState({
      isCropping: false
    });
  }

  setThumbnail = (image: string): void => {
    this.setState({
      thumbnailImageData: image
    });
    this.props.setLogo(image);
  };

  render() {
    return (
      <div className='AvatarInput'>
        <label htmlFor='photo'>
          {
            this.state.thumbnailImageData
              ? (<img src={this.state.thumbnailImageData} alt='avatar thumbnail' />)
              : (<p><span className='plus-sign'>+</span><br />Photo</p>)
          }
          <input accept='image/jpg,image/png' className='step2' type='file' name='photo' id='photo' placeholder='Photo' onChange={this.onInputChanged} />
        </label>
        <ImageCropper
          contentLabel='Avatar Upload'
          isOpen={this.state.isCropping}
          closeModal={this.closeModal}
          image={this.state.avatarImage}
          setThumbnail={this.setThumbnail}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AvatarInput/AvatarInput.jsx